import { keyBy } from 'lodash';
import topMoverService from '../../../../core/services/Market/TopMover/TopMoverService';
import reducerRegistry from '../../../helpers/ReducerRegistry';
import Interval from '../../../../../src/component/helpers/IntervalCallApi';
import Const from '../Const';
import { handleExport } from '../../../helpers/HandleExport';

const REDUCER_NAME = 'TOP_GAINERS:OVERVIEW:';
const FETCH_LIST_OVERVIEW_TABLE = `${REDUCER_NAME}FETCH_LIST_OVERVIEW_TABLE`;
const SUBSCRIBE_REALTIME_TICK = `${REDUCER_NAME}SUBSCRIBE_REALTIME_TICK`;
const UPDATE_CHART_IMAGE = `${REDUCER_NAME}UPDATE_CHART_IMAGE`;
const FETCH_CHART_IMAGE = `${REDUCER_NAME}FETCH_CHART_IMAGE`;
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const SET_LOADING = `${REDUCER_NAME}SET_LOADING`;
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;
const CHANGE_SORT_STATE = `${REDUCER_NAME}CHANGE_SORT_STATE`;

export {
  REDUCER_NAME,
  exportTopGainerData,
  fetchListTopGainerTable,
  cancelFetchListTopGainerTable,
  subscribeRealtimeTickTopGainers,
  fetchChartImage,
  changeSortState,
};

function cancelFetchListTopGainerTable() {
  return () => {
    Interval.cancel('TopGainers');
  };
}

function changeSortState(sortState) {
  return {
    type: CHANGE_SORT_STATE,
    payload: sortState,
  };
}

function exportTopGainerData(ComGroupCode = null, Screen, filename) {
  const apiParam = {
    ComGroupCode,
    Screen,
  };
  return dispatch => {
    topMoverService.downloadTopGainer({ ...apiParam }).then(response => {
      handleExport(response, filename);
    });
  };
}

function fetchListTopGainerTable(filter = 'All') {
  return dispatch => {
    Interval.fetch(
      'TopGainers',
      dispatch,
      () => {
        dispatch(setLoading(true));
        return topMoverService.getDataTopGainersOverview({
          ComGroupCode: filter,
        });
      },
      response => {
        if (response) {
          const listDataTopGainers = response.items || [];
          dispatch({
            type: FETCH_LIST_OVERVIEW_TABLE,
            payload: {
              listDataTopGainers,
            },
          });
        }
        dispatch(setLoading(false));
      },
      Const.topGainersInterval,
      err => dispatch(setLoading(false)),
    );
  };
}

function subscribeRealtimeTickTopGainers(data) {
  return {
    type: SUBSCRIBE_REALTIME_TICK,
    payload: {
      data,
    },
  };
}

function fetchChartImage(organCode, theme) {
  return dispatch => {
    topMoverService
      .getTopVolumeChartImage({
        organCode,
        theme,
      })
      .then(({ items }) => {
        dispatch({
          type: UPDATE_CHART_IMAGE,
          payload: {
            organCode,
            image: items ? items[0] : '',
          },
        });
      });
  };
}

function setLoading(isLoading) {
  return dispatch => {
    dispatch({
      type: SET_LOADING,
      payload: isLoading,
    });
  };
}

const initialState = {
  listDataTopGainersTicker: [],
  listObjectDataTopGainersByTicker: {},
  images: {},
  component: {},
  isLoading: false,
  sortState: {},
  exportFilter: null,
};

function reducer(globalState = {}, action) {
  switch (action.type) {
    case INIT_COMPONENT:
      return {
        ...globalState,
        ...initialState,
      };

    case UNMOUNT_COMPONENT:
      return {};

    case FETCH_LIST_OVERVIEW_TABLE:
      const listObjectDataTopGainersByTicker = keyBy(
        action.payload.listDataTopGainers,
        'organCode',
      );
      const listDataTopGainersTicker = action.payload.listDataTopGainers.map(
        item => item.organCode,
      );
      return {
        ...globalState,
        listDataTopGainersTicker,
        listObjectDataTopGainersByTicker,
      };

    case SUBSCRIBE_REALTIME_TICK:
      const listObjectDataTopGainersByTickerNew = {
        ...globalState.listObjectDataTopGainersByTicker,
      };

      action.payload.data.forEach(item => {
        if (listObjectDataTopGainersByTickerNew[item.organCode]) {
          const tickerItem = {
            ...listObjectDataTopGainersByTickerNew[item.organCode],
          };

          if (tickerItem) {
            tickerItem.volume = item.totalMatchVolume;
            tickerItem.price = item.matchPrice;
            tickerItem.percentPriceChange = item.percentPriceChange;
            tickerItem.tradingDate = item.tradingDate;
            tickerItem.performance.percentPriceChange1Day =
              item.percentPriceChange;
          }
          listObjectDataTopGainersByTickerNew[item.organCode] = tickerItem;
        }
      });

      return {
        ...globalState,
        listObjectDataTopGainersByTicker: listObjectDataTopGainersByTickerNew,
      };

    case FETCH_CHART_IMAGE:
      const dataChartImage = action.payload.dataChartImage;
      return { ...globalState, dataChartImage };

    case UPDATE_CHART_IMAGE:
      return {
        ...globalState,
        images: {
          ...globalState.images,
          [action.payload.organCode]: action.payload.image,
        },
      };

    case CHANGE_SIZE_COMPONENT:
      return {
        ...globalState,
        component: action.payload,
      };

    case SET_LOADING:
      return {
        ...globalState,
        isLoading: action.payload,
      };

    case CHANGE_SORT_STATE:
      return {
        ...globalState,
        sortState: action.payload,
        exportFilter: action.payload,
      };

    default:
      return globalState;
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);
